import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  useDisclosure,
  Box,
  Center,
  Text
} from '@chakra-ui/react'
import { FC } from 'react'

import useParametrizationRevision from '@hook/parametrization/use-revision'

const ParametrizationRevisionModalApproved: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { approved } = useParametrizationRevision()

  return (
    <>
      <Button
        colorScheme="green"
        variant="outline"
        onClick={onOpen}
        fontSize={14}
        size="sm"
        borderRadius={5}
        cursor="pointer"
        transition="all ease .2s"
        _hover={{
          background: '#c0ffc9',
          color: '#1d4b1d'
        }}
      >
        Aprovar Solicitações
      </Button>
      <Modal
        isCentered
        isOpen={isOpen}
        onClose={onClose}
        scrollBehavior="inside"
        motionPreset="slideInBottom"
        colorScheme="white"
        size="lg"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalBody bg="white" pt={0} py={4}>
            <Box p={6}>
              <Text fontSize="3xl" align="center">
                Alteração de Status
              </Text>
              <Text align="center" fontSize="sm">
                tem certeza que desejar aceitar a solicitação
              </Text>
            </Box>
            <Center>
              <Box p={2} alignItems="center" alignContent="center">
                <Button
                  colorScheme="green"
                  mr={3}
                  onClick={() => {
                    approved()
                    onClose()
                  }}
                  alignItems="center"
                >
                  Sim
                </Button>
                <Button colorScheme="red" mr={3} onClick={onClose}>
                  Não
                </Button>
              </Box>
            </Center>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ParametrizationRevisionModalApproved
